<script>
    import GraficoPolarArea from "./../graphics/graficoPolarArea.svelte";
    import GraficoLine from "../graphics/graficoBar.svelte";
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    
    export let data_line = {
    };

    export let data_PolarArea = {                      
    };

    export let name = "";

    let controlView = {
        btnopc: false
    };

</script>

<div class="col-md-6">
    <!-- AREA CHART -->
    <div class="card card-info">
        <div class="card-header">
            <h3 class="card-title">
                {name}
            </h3>

            <div class="card-tools">
                <button
                    type="button"
                    class="btn btn-tool"
                    on:click={() => (controlView.btnopc = true)}
                >
                    <i class="ion ion-pie-graph" />
                </button>
                <button
                    type="button"
                    class="btn btn-tool"
                    on:click={() => (controlView.btnopc = false)}
                >
                    <i class="bi bi-bar-chart-line" />
                </button>
                <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                >
                    <i class="fas fa-times" />
                </button>
            </div>
        </div>

        <div class="card-body pt-1">
            {#if controlView.btnopc}
                <GraficoPolarArea data={data_PolarArea.data} />
            {:else}
                <GraficoLine data={data_line.data} />
            {/if}
        </div>

        <!-- /.card-body -->
    </div>
    <!-- /.card -->
</div>
